import { extendTheme, ThemeOverride } from '@chakra-ui/react';
import { defaultTheme as uiTheme } from '@netiva/classifieds-ui';

import { Instance } from '@/environment';
import {
  Accordion,
  Alert,
  Header,
  Footer,
  Input,
  ReactSelect,
  Select,
  Sidebar,
  Steps,
  Button,
  SelectableCard,
  Textarea,
} from './components';
export * from './components';

const platformTheme = (await import(`./platforms/${Instance}.ts`)).default || {};

export const faviconPath = `/assets/favicons/${Instance}.ico`;

const theme = extendTheme(
  uiTheme,
  {
    breakpoints: {
      sm: '480px',
      md: '768px',
      lg: '1200px',
      xl: '1600px',
      '2xl': '1800px',
    },
    fonts: {
      body: `'IBM Plex Sans', sans-serif`,
      heading: `'IBM Plex Sans', sans-serif`,
    },
    transitions: {
      default: '2s ease',
    },
    components: {
      Accordion,
      Alert,
      Button,
      Input,
      ReactSelect,
      Select,
      SelectableCard,
      Textarea,
      Header,
      Footer,
      Sidebar,
      Steps,
    },
  } as ThemeOverride,
  platformTheme
);

export default theme;
